import React from 'react'
import { useStyletron } from '../../../../theme'
import { BUTTON_KIND, BUTTON_USE } from '../../../Buttons'
import Button from '../../../Buttons/Button'

export enum DIRECTION {
    LEFT = 'left',
    RIGHT = 'right'
}

export interface YearSwitchButton {
    disabled: boolean
    onClick: () => void
    direction: DIRECTION
}

const YearSwitchButton = ({ disabled, onClick, direction }: YearSwitchButton) => {
    const [, theme] = useStyletron()

    return (
        <Button
            disabled={disabled}
            $use={BUTTON_USE.icon}
            $kind={BUTTON_KIND.ghost}
            onClick={onClick}
            overrides={{
                BaseButton: {
                    style: {
                        color: theme.colors.black,
                        ...(!disabled && {
                            ':hover': {
                                color: theme.colors.black,
                                backgroundColor: 'transparent',
                                borderColor: 'transparent'
                            },
                            ':active': {
                                color: theme.colors.black,
                                backgroundColor: 'transparent',
                                borderColor: 'transparent'
                            },
                            ':selected': {
                                color: theme.colors.black,
                                backgroundColor: 'transparent',
                                borderColor: 'transparent'
                            },
                            ':focus': {
                                color: theme.colors.black,
                                backgroundColor: 'transparent',
                                borderColor: 'transparent'
                            }
                        })
                    }
                }
            }}
        >
            <i className={`wemolo-chevron-${direction}`} />
        </Button>
    )
}

export default YearSwitchButton
